export default {
    methods: {
        appendPrintStyle({size, margin, padding}) {
            const style = document.createElement('style');
            const cssText =
                `@media print {
                    @page {
                        size: ${size};
                        margin: ${margin};
                        padding: ${padding};
                    }
                }`

            style.type = 'text/css';
            // Set id attribute to get style element later
            style.setAttribute('id', 'print-style');
            if (style.styleSheet) {
                // This is required for IE8 and below.
                style.styleSheet.cssText = cssText;
            } else {
                style.appendChild(document.createTextNode(cssText));
            }
            const head = document.head || document.getElementsByTagName('head')[0];
            head.appendChild(style);
        },
        removePrintStyle() {
            const style = document.getElementById('print-style');
            if (style) {
                style.remove();
            }
        }
    }
}
